import { render, staticRenderFns } from "./DetailSupplier.vue?vue&type=template&id=3c927819"
import script from "./DetailSupplier.vue?vue&type=script&lang=js"
export * from "./DetailSupplier.vue?vue&type=script&lang=js"
import style0 from "./DetailSupplier.vue?vue&type=style&index=0&id=3c927819&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports